import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { fetchTakeABreakDetails, TakeABreakResponse } from '@core/Areas/Account/TakeABreak/api'
import { useLogon } from '@core/Utils/hooks'

export function useTakeABreak() {
  const { accountNumber } = useLogon()

  const { data, isError, error, isSuccess, isLoading } = useQuery<TakeABreakResponse, unknown>({
    queryKey: [queryKeys.takeABreak, accountNumber],
    queryFn: fetchTakeABreakDetails,
    gcTime: accountNumber ? 300000 : 0,
    enabled: !!accountNumber,
  })

  return { data, isLoading, isError, error, isSuccess }
}
